module.exports = __webpack_public_path__ + "img/ke.0bbfd05.svg";